/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: queue-priority-modal-component.ts
 *
 * Created by kyang on 2019-10-14.
 */

function QueuePriorityModalController(
    this: JS5Object,
) {

    //================//
    // Template Logic //
    //================//

    this.okButtonEnabled = () => {
        return this.editorForm.$valid && this.editorForm.$dirty;
    };

    let getStepPriority = (queueStep: JS5Object) => {
        if (queueStep.priorityOverride) {
            return parseInt(queueStep.priorityOverride);
        }
        return parseInt(queueStep.priority);
    };

    this.onOkClicked = () => {
        let changedQueueSteps: JS5Object[] = [];
        let newPriority = `${this.priority}`;
        _.forEach(this.queueSteps, (queueStep: JS5Object) => {
            if (getStepPriority(queueStep) !== this.priority) {
                delete queueStep.priorityOverride;
                queueStep.priority = newPriority;
                changedQueueSteps.push(queueStep);
            }
        });

        this.close({
            $value: changedQueueSteps
        });
    };

    this.onCancelClicked = () => {
        this.dismiss();
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.queueSteps = this.resolve.queueSteps;
        this.priority = getStepPriority(this.queueSteps[0]);
        if (_.some(this.queueSteps, (queueStep: JS5Object) => {
            return getStepPriority(queueStep) !== this.priority;
        })) {
            this.priority = null;
        }
    };
}

angular
    .module('prism-ui.components')
    .component(
        'queuePriorityModal',
        {
            controller: QueuePriorityModalController,
            templateUrl: 'components/modal/queue-priority-modal/queue-priority-modal-template.html',
            bindings: {
                resolve: '<',
                close: '&',
                dismiss: '&'
            }
        }
    );
